import {
    Box,
    Button,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Typography,
  } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useState } from "react";
import { Auth } from "aws-amplify";
import VisibilityOffOutlined from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import theme from "../../styles/styleTheme";
import LoginIcon from "@mui/icons-material/Login";
import Check from "../../assets/images/auth/check.svg";
import NAV from "../../utils/nav.const";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import AuthContainer from "./AuthContainer";
  
const ResetPassword = () => {
const { code, username } = useParams();
const navigate = useNavigate();
const [completed, setCompleted] = useState<boolean>(false);
const [passwordError, setPasswordError] = useState<boolean>(false);

const [password1, setPassword1] = useState<string>("");
const [password2, setPassword2] = useState<string>("");

const [showPassword1, setShowPassword1] = useState<boolean>(false);
const [showPassword2, setShowPassword2] = useState<boolean>(false);

const handleClickShowPassword = () =>
    setShowPassword1((show: boolean) => !show);

const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
};

const handleClickShowPassword2 = () =>
    setShowPassword2((show: boolean) => !show);

const handleMouseDownPassword2 = (event: any) => {
    event.preventDefault();
};

const resetPassword = async () => {
    if (username && code) {
    await Auth.forgotPasswordSubmit(username, code, password1).finally(() => {
        setCompleted(true);
    });
    }
};

return (
    <motion.div
    initial={{ opacity: 0, scale: 0.5, originY: "100px" }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.7 }}
    >
    {!completed && (
        <AuthContainer title="Wachtwoord opnieuw instellen">
        <Grid display={"flex"} container spacing={2}>
            <Grid item xs={12}>
            <Typography>
                Stel een nieuw wachtwoord in door hieronder uw nieuwe wachtwoord
                in te voeren en te bevestigen.
            </Typography>
            </Grid>
            <Grid item xs={12}>
            <Box
                display={"flex"}
                alignItems={"center"}
                gap={1}
                sx={{ opacity: passwordError ? 1 : 0 }}
            >
                <ErrorOutlineOutlinedIcon color="primary" />
                <Typography
                variant="body2"
                sx={{
                    color: theme.palette.primary.main,
                }}
                fontWeight={"bold"}
                >
                Wachtwoorden komen niet overeen
                </Typography>
            </Box>
            </Grid>
            <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
                <InputLabel>Nieuw wachtwoord</InputLabel>
                <OutlinedInput
                fullWidth
                id="outlined-adornment-password"
                type={showPassword1 ? "text" : "password"}
                endAdornment={
                    <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                    >
                        {showPassword1 ? (
                        <VisibilityOutlinedIcon />
                        ) : (
                        <VisibilityOffOutlined />
                        )}
                    </IconButton>
                    </InputAdornment>
                }
                label="Nieuw wachtwoord"
                onChange={(event: any) => setPassword1(event.target.value)}
                />
            </FormControl>
            </Grid>
            <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
                <InputLabel>Nieuwe wachtwoord bevesitigen</InputLabel>
                <OutlinedInput
                fullWidth
                id="outlined-adornment-password"
                type={showPassword2 ? "text" : "password"}
                endAdornment={
                    <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword2}
                        onMouseDown={handleMouseDownPassword2}
                        edge="end"
                    >
                        {showPassword2 ? (
                        <VisibilityOutlinedIcon />
                        ) : (
                        <VisibilityOffOutlined />
                        )}
                    </IconButton>
                    </InputAdornment>
                }
                label="Nieuwe wachtwoord bevesitigen"
                onChange={(event: any) => setPassword2(event.target.value)}
                />
            </FormControl>
            </Grid>
            <Grid display={"flex"} justifyContent={"flex-end"} item xs={12}>
            <Button
                disableRipple
                variant="contained"
                sx={{ color: "#fff" }}
                disabled={password1 === "" || password2 === ""}
                onClick={() => {
                password1 === password2
                    ? resetPassword()
                    : setPasswordError(true);
                }}
            >
                Versturen
            </Button>
            </Grid>
        </Grid>
        </AuthContainer>
    )}
    {completed && (
        <>
        <motion.div
            initial={{ opacity: 0, scale: 0.5, originY: "100px" }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
        >
            <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "90vh", textAlign: "center" }}
            >
            <Grid item xs={12}>
                <img src={Check} height={160} alt="Verify Email" />
            </Grid>
            <Grid padding={2} item xs={12}>
                <Typography color="primary" variant="h1">
                Wachtwoord succesvol gewijzigd!
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1">
                Je kunt nu inloggen met je nieuwe wachtwoord.
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ margin: "20px 0" }}>
                <Button
                startIcon={<LoginIcon />}
                onClick={() => navigate("/" + NAV.SIGNIN)}
                variant="outlined"
                >
                    Inloggen
                </Button>
            </Grid>
            </Grid>
        </motion.div>
        </>
    )}
    </motion.div>
);
};
  
  export default ResetPassword;
  